import React from 'react';
import { Box, Theme, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { green } from '@mui/material/colors';

interface Props {
  creditTiersResult?: any;
}

export const TierCell = ({ creditTiersResult }: Props) => {
  const classes = useStyles({ highestTierColor: creditTiersResult?.highestTierColor });

  return (
    <>
      {creditTiersResult?.runtimeOutput?.event?.params?.financeProgram?.prescreenCriteria?.jsonCriteria?.find(
        (criteria: any) => criteria?.name === creditTiersResult?.highestTierPassed
      ) ? (
        <Tooltip title={creditTiersResult?.highestTierPassed}>
          <Box className={classes.tierIcon} />
        </Tooltip>
      ) : (
        '-'
      )}
    </>
  );
};

const useStyles = makeStyles<Theme, { highestTierColor: string }>({
  tierIcon: {
    width: '1rem',
    height: '1rem',
    minWidth: '1rem',
    borderRadius: '50%',
    backgroundColor: ({ highestTierColor }) => highestTierColor ?? green['500'],
    border: '1px solid #ccc',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    margin: '0 auto',
  },
});
